import { render, staticRenderFns } from "./AssessmentItem.vue?vue&type=template&id=01a7f215&"
import script from "./AssessmentItem.vue?vue&type=script&lang=js&"
export * from "./AssessmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports